import { useAuthStore } from '../../stores/auth.store';
import { formatCurrency } from '../../lib/currency';
import type { Inventory } from '@motra/shared';

interface ProductGridProps {
  items: Inventory[];
  onAddToBasket: (item: Inventory) => void;
  loading?: boolean;
}

export default function ProductGrid({ items, onAddToBasket, loading = false }: ProductGridProps) {
  const shop = useAuthStore((s) => s.shop);
  const currSym = shop?.curr_sym ?? '$';

  if (loading) {
    return (
      <div className="product-grid product-grid--loading">
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} className="product-card product-card--skeleton" />
        ))}
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="product-grid product-grid--empty">
        <p>No products found</p>
      </div>
    );
  }

  return (
    <div className="product-grid">
      {items.map((item) => {
        const qty = item.qty ?? 0;
        const isLow = qty > 0 && qty < 4;
        return (
          <button
            key={item.id}
            className={`product-card${qty === 0 ? ' product-card--out-of-stock' : ''}`}
            onClick={() => qty !== 0 && onAddToBasket(item)}
            disabled={qty === 0}
            title={item.description ?? item.name ?? ''}
          >
            <div className="product-card__img-wrap">
              <div className="product-card__img-placeholder">
                <span className="product-card__category-badge">{item.category ?? ''}</span>
              </div>
              {/* Qty badge overlay — legacy style */}
              <span className={`product-card__qtymark${isLow ? ' product-card__qtymark--low' : ''}${qty === 0 ? ' product-card__qtymark--oos' : ''}`}>
                {qty}
              </span>
            </div>
            <div className="product-card__info">
              <p className="product-card__name">{item.name ?? 'Unnamed'}</p>
              <div className="product-card__pricing">
                {item.pprice != null && item.pprice < (item.price ?? Infinity) ? (
                  <>
                    <span className="product-card__promo-price">
                      {formatCurrency(item.pprice, currSym)}
                    </span>
                    <span className="product-card__price product-card__price--struck">
                      {formatCurrency(item.price ?? 0, currSym)}
                    </span>
                  </>
                ) : (
                  <span className="product-card__price">
                    {formatCurrency(item.price ?? 0, currSym)}
                  </span>
                )}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
